<app-navbar title="Wpłaty wynajmy"> </app-navbar>

<div class="col-sm-2 p-3" *ngIf="data['summary']?.length > 0">
	<app-bag-payment-list-table-summary
		[data]="data['summary']"
		[tableColumns]="summaryColumns"
	></app-bag-payment-list-table-summary>
</div>

<app-event-business-payments-table-filters
	userFilters="payments"
	[organization]="parameters.organization"
	[profile]="parameters.profile"
	(selected)="filtersSelected($event)"
>
</app-event-business-payments-table-filters>

<app-dynamic-table-v2
	[module]="'eventBusiness'"
	[elements]="data"
	[elementLinkPostfix]="'payments'"
	[columns]="tableColumnsDef"
	[pageSizeOptions]="pageSizeOptions"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table-v2>
